import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/55d8a1fb/src/components/layout.js";
import Layout from "../../components/layout";
import { Link } from "gatsby";
import { PrimaryButton } from "../../components/Buttons";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`Good news, you're probably covered!`}</h1>
    <p>{`Most renters, whether you live in a traditional apartment, a rented condo, or a detached house, will be covered by the new law.`}</p>
    <p>{`That said, there are a few exceptions, so we can help you figure out your specific coverage.`}</p>
    <h3>{`Sound good?`}</h3>
    <PrimaryButton to="/coverage/existing-rent-control-check" mdxType="PrimaryButton">Yes</PrimaryButton>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      